import { render } from "./ProductColor.vue?vue&type=template&id=295b25e2"
import script from "./ProductColor.vue?vue&type=script&lang=js"
export * from "./ProductColor.vue?vue&type=script&lang=js"
script.render = render

export default script